import { render, staticRenderFns } from "./packageBookings.vue?vue&type=template&id=dc3ec092"
import script from "./packageBookings.vue?vue&type=script&lang=js"
export * from "./packageBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports